import { _ as _ts_decorate } from "@swc/helpers/_/_ts_decorate";
import { _ as _ts_metadata } from "@swc/helpers/_/_ts_metadata";
import { observable, runInAction, computed, flow } from "mobx";
import { locationRestScannerResultIgnorePost } from "../wp-api";
import { ServiceTemplate } from ".";
import { request } from "../utils";
class ScannerResultTemplate {
    get identifier() {
        return this.data.identifier;
    }
    get type() {
        return this.templateModel instanceof ServiceTemplate ? "service" : "blocker";
    }
    /**
     * Determines if this template needs further attention. It is inactive when it e.g. already exists.
     */ get inactive() {
        return this.data.consumerData["isCreated"] || this.data.consumerData["isIgnored"];
    }
    constructor(template, store){
        this.busy = false;
        this.ignore = flow(function*(state) {
            this.busy = true;
            try {
                yield request({
                    location: locationRestScannerResultIgnorePost,
                    request: {
                        type: "template",
                        value: this.identifier,
                        ignored: state
                    }
                });
                this.data.consumerData.isIgnored = state;
            } catch (e) {
                console.log(e);
                throw e;
            } finally{
                this.busy = false;
            }
        });
        runInAction(()=>{
            this.data = template;
        });
        this.store = store;
        const { cookieStore } = store.rootStore;
        if (Object.hasOwn(template, "rules")) {
            cookieStore.addBlockerTemplates([
                template
            ]);
            this.templateModel = cookieStore.templatesBlocker.get(template.identifier);
        } else {
            cookieStore.addServiceTemplates([
                template
            ]);
            this.templateModel = cookieStore.templatesServices.get(template.identifier);
        }
    }
}
_ts_decorate([
    observable
], ScannerResultTemplate.prototype, "busy", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], ScannerResultTemplate.prototype, "data", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], ScannerResultTemplate.prototype, "templateModel", void 0);
_ts_decorate([
    computed,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", void 0)
], ScannerResultTemplate.prototype, "identifier", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", void 0)
], ScannerResultTemplate.prototype, "type", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", void 0)
], ScannerResultTemplate.prototype, "inactive", null);
export { ScannerResultTemplate };
